<template>
    <v-container>
        <div id="inicio" style="margin-top: -5%;">
            <!-- <h1>Banco de Casos de corrupción</h1>         -->
            <div style="text-align: justify;">
                <v-row>
                    <v-col cols="12" md="12" lg="12">
                        <h2>¿Qué es el Banco de Casos?</h2>
                        <p style="font-size: 14px;">                            
                            El Banco de Casos de Corrupción en Colombia es una herramienta esencial para la prevención y lucha contra la corrupción. Este repositorio 
                            está disponible para la consulta de la ciudadanía, funcionarios públicos y actores del sector privado, facilitando el acceso a información 
                            estratégica sobre casos de corrupción. Su objetivo es promover una mayor transparencia, integridad y comprensión de las manifestaciones de 
                            este fenómeno en el país.
                        </p>
                        <h2>¿Por qué es importante un Banco de Casos?</h2>
                            <p>
                            La corrupción es un fenómeno complejo que requiere información para su análisis y monitoreo. Por ello, el Banco de Casos se suma a las diversas 
                            bases y plataformas de información que la Secretaría de Transparencia pone a disposición, con el fin de mejorar la prevención, detección y 
                            visibilidad de casos de corrupción, especialmente en sectores problemáticos y de alto impacto, como los delitos ambientales.<br><br>

                            El Banco de casos es importante porque…
                            <ul>
                                <li>
                                    La recopilación sistemática y estructurada de casos de corrupción no solo sirve como un registro histórico, sino que proporciona una 
                                    invaluable fuente de información para analizar patrones, identificar vulnerabilidades institucionales y establecer estrategias preventivas 
                                    y correctivas.
                                </li>
                                <li>
                                    Sirve como una guía para las entidades públicas, sociedad civil investigadores y organizaciones que luchan contra la corrupción, facilita 
                                    la identificación de patrones, tipologías, áreas vulnerables y prácticas corruptas.
                                </li>
                                <li>
                                    Contribuye en el fortalecimiento de las capacidades institucionales para prevenir, investigar y sancionar actos de corrupción al proporcionar 
                                    información de casos concretos con evidencia no solo de las distintas modalidades utilizadas, sino los impactos generados. 
                                </li>
                                <li>
                                    Fomenta la transparencia, el control social y la veeduría ciudadana al ser información puesta a disposición de la ciudadanía para el seguimiento 
                                    a políticas, programas, proyectos inmersos en actos de corrupción. 
                                </li>
                            </ul>
                        </p>
                    </v-col>
                    <v-col cols="12" md="12" lg="1" style="background-color: rgb(230, 233, 242); height: 25%; position: fixed; right: 15px;">
                        <h3>Menú</h3>
                        <div>
                            <a href="#" v-scroll-to="'#inicio'" style="text-decoration: none;">
                                <p class="p1">Inicio</p>
                            </a>
                            <a href="#" v-scroll-to="'#lista'" style="text-decoration: none;">
                                <p class="p1">Casos</p>
                            </a>
                            <a href="#" v-scroll-to="'#map'" style="text-decoration: none;">
                                <p class="p1">Mapa</p>
                            </a>
                            <a href="#" v-scroll-to="'#estadistica'" style="text-decoration: none;">
                                <p class="p1">Estadísticas</p>
                            </a>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </div>
        <!--REGISTRAR NUEVO O ACTUALIZAR-->
        <div>
            <v-dialog v-model="dialog" max-width="80%" persistent>
                <template v-slot:activator="{ on }">
                    <v-row>
                        <v-col cols="12" md="12" lg="2">
                            <v-btn color="primary" dark class="mb-2" v-on="on" @click="nueva">Nuevo Caso</v-btn>
                        </v-col>
                    </v-row> 
                </template>                            
                <v-card>
                    <v-card-title>
                        <span class="text-h5">{{ formTitle }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-row wrap>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="dato.nom_caso" label="Nombre del Caso" class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-menu
                                        ref="menu1"
                                        v-model="menu1"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        :return-value.sync="dato.fecha"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field v-model="dato.fecha" label="Fecha" prepend-icon="event" readonly v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="dato.fecha" no-title scrollable>
                                        <v-spacer></v-spacer>
                                            <v-btn color="primary" @click="menu1 = false">Cancel</v-btn>
                                            <v-btn color="primary" @click="$refs.menu1.save(dato.fecha)">OK</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-select v-model="dato.oid_municipio" :items="municipios" item-text="n_municipio" item-value="oid" label="Municipio"></v-select>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-select v-model="dato.oid_depto" :items="deptos" item-text="n_depto" item-value="oid" label="Departamento"></v-select>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="dato.area_protegida" label="Área protegia involucrada" class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-select v-model="dato.oid_actor" :items="actores" item-text="n_actor" item-value="oid" label="Tipo de actor involucrado"></v-select>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="dato.tipo_delito" label="Tipo de delito" class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="dato.tipo_corrupcion" label="Tipo de corrupción" class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="dato.condena" label="Condena" class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="dato.resolucion" label="Resolución" class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="dato.año_investigacion" label="Año de apertura de la investigación" class="rounded" :rules="[validarnumero]"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="dato.tipo_sancion" label="Tipo de sanción" class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="dato.monto" label="Monto de dinero" class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="dato.beneficios_ilegal" label="Beneficios ilegales" class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="dato.perjuicios" label="Perjuicios" class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="5">
                                    <v-text-field v-model="dato.tipo_daño" label="Tipo de daño" class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="5">
                                    <v-text-field v-model="dato.mecanismo" label="Mecanismos utilizados" class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="dato.sector_afectado" label="Sector afectado" class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="dato.investigacion" label="Investigación y juicio" class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="dato.sancion" label="Sanciones" class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="dato.imp_social" label="Impacto social" class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="dato.imp_economico" label="Impacto Economico" class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="dato.fuentes" label="Fuentes de información" class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="dato.estado_actual" label="Estado actual" class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="dato.lecciones" label="Lecciones aprendidas" class="rounded"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="cerrar">Cancelar</v-btn>
                        <v-btn color="blue darken-1" text @click="guardar">{{ isNew ? 'Registrar' : 'Actualizar' }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
        <!--TABLA DE DATOS-->
        <div id="lista">
            <v-row>
                <v-col cols="12" md="12" lg="4">
                    <v-text-field v-model="search" append-icon="search" label="Buscar por Nombre del Caso" outlined dense></v-text-field>
                </v-col>
                <v-col cols="12" lg="2">
                    <v-select v-model="FiltroMunicipios" :items="optionsMunicipios" item-text="n_municipio" item-value="oid" label="Filtrar por Municipios" outlined dense multiple></v-select>
                </v-col>                
                <v-col cols="12" lg="2">
                    <v-select v-model="FiltroDeptos" :items="optionsDeptos" item-text="n_depto" item-value="oid" label="Filtrar por Deptos" outlined dense multiple></v-select>
                </v-col>
                <v-col cols="12" lg="2">
                    <v-select v-model="FiltroActores" :items="optionsActores" item-text="n_actor" item-value="oid" label="Filtrar por Actores" outlined dense multiple></v-select>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="12" lg="12">
                    <h2>Lista de Casos - LISTA</h2>
                    <v-data-table :headers="headers" :items="filtered" item-key="id">
                        <template v-slot:items="props">
                            <td>{{ props.item.oid }}</td>
                            <td>{{ props.item.nom_caso }}</td>
                            <td>{{ props.item.fecha }}</td>                        
                            <td>{{ props.item.oid_municipio }}</td>
                            <td>{{ props.item.oid_depto }}</td>
                            <td>{{ props.item.area_protegida }}</td>
                            <td>{{ props.item.oid_actor }}</td>
                            <td>{{ props.item.tipo_delito }}</td>
                            <td>{{ props.item.tipo_corrupcion }}</td>
                        <td class="text-center">
                            <v-btn small color="primary" @click="mostrar(props.item.id)">Mostrar</v-btn>
                            <v-btn small color="warning" @click="editar(props.item)">Editar</v-btn>
                            <v-btn small color="error" @click="confirmarEliminar(props.item.id)">Eliminar</v-btn>
                        </td>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>            
        </div>
        <div id="map" style="height: 600px;"></div>
        <div>
            <!-- Diálogo para ver detalle-->
            <v-dialog v-model="dialogdetail" max-width="80%">
                <v-card>
                    <v-card-title class="headline">Detalle</v-card-title>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-row wrap>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="dato.nom_caso" label="Nombre del Caso" readonly disabled class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-text-field v-model="dato.fecha" label="Fecha" readonly disabled class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-select v-model="dato.oid_municipio" :items="municipios" item-text="n_municipio" item-value="oid" label="Municipio" readonly disabled></v-select>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-select v-model="dato.oid_depto" :items="deptos" item-text="n_depto" item-value="oid" label="Departamento" readonly disabled></v-select>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="dato.area_protegida" label="Área protegia involucrada" class="rounded" readonly disabled></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-select v-model="dato.oid_actor" :items="actores" item-text="n_actor" item-value="oid" label="Tipo de actor involucrado" readonly disabled></v-select>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="dato.tipo_delito" label="Tipo de delito" readonly disabled class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="dato.tipo_corrupcion" label="Tipo de corrupción" readonly disabled class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="dato.condena" label="Condena" readonly disabled class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="dato.resolucion" label="Resolución" readonly disabled class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="dato.año_investigacion" label="Año de apertura de la investigación" readonly disabled class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="dato.tipo_sancion" label="Tipo de sanción" readonly disabled class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="dato.monto" label="Monto de dinero" readonly disabled class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="dato.beneficios_ilegal" label="Beneficios ilegales" readonly disabled class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="dato.perjuicios" label="Perjuicios" readonly disabled class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="5">
                                    <v-text-field v-model="dato.tipo_daño" label="Tipo de daño" readonly disabled class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="5">
                                    <v-text-field v-model="dato.mecanismo" label="Mecanismos utilizados" readonly disabled class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="dato.sector_afectado" label="Sector afectado" readonly disabled class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="dato.investigacion" label="Investigación y juicio" readonly disabled class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="dato.sancion" label="Sanciones" readonly disabled class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="dato.imp_social" label="Impacto social" readonly disabled class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="dato.imp_economico" label="Impacto Economico" readonly disabled class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="dato.fuentes" label="Fuentes de información" readonly disabled class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="dato.estado_actual" label="Estado actual" readonly disabled class="rounded"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="dato.lecciones" label="Lecciones aprendidas" readonly disabled class="rounded"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="secondary" text @click="cancelarDetalle">Cerrar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <!-- Diálogo de confirmación para eliminar -->
            <v-dialog v-model="showConfirmDialog" max-width="35%">
                    <v-card>
                    <v-card-title class="headline">Confirmar eliminación</v-card-title>
                    <v-card-text>
                        ¿Está seguro de que desea eliminar este registro?
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary" text @click="eliminar(confirmItemId)">Sí</v-btn>
                        <v-btn color="secondary" text @click="cancelarEliminar">No</v-btn>
                    </v-card-actions>
                    </v-card>
            </v-dialog>

            <!-- Dialogo para Mensaje cargando-->
            <v-dialog v-model="dialog_guardando" max-width="550px"> 
                <v-card>
                    <v-card-title class="headline">Guardando.....</v-card-title>
                </v-card>
            </v-dialog>

            <!-- Mensaje de confirmación-->
            <v-snackbar v-model="guardarExitoso" color="success" top>
                Guardado exitosamente
                <template v-slot:action="{ attrs }">
                    <v-btn color="success" text v-bind="attrs" @click="registroExitoso = false">Cerrar</v-btn>
                </template>
            </v-snackbar>
        </div>
    </v-container>
</template>


<script>
import L from 'leaflet';
import axios from 'axios';
import VueScrollTo from 'vue-scrollto';
import SectionTitle from '@/components/SectionTitle.vue';

async function obtenerTokenCSRF() {
    try {
        const response = await axios.get('/token');
        return response.data;
    } catch (error) {
        console.error('Error al obtener el token CSRF:', error);
        return null;
    }
}

export default {
  components: {
    SectionTitle
  },
    data() {
        return {
            datos: [],
            dato: {
                oid: 0,
                nom_caso: '',
                fecha: null,
                oid_municipio: '',
                oid_depto: '',
                area_protegida: '',
                oid_actor: '',
                tipo_delito: '',
                tipo_corrupcion: '',
                condena: "",
                resolucion: "",
                año_investigacion: 0,
                tipo_sancion: "",
                monto: "",
                beneficios_ilegal: "",
                perjuicios: "",
                tipo_daño: "",
                mecanismo: "",
                sector_afectado: "",
                investigacion: "",
                sancion: "",
                imp_social: "",
                imp_economico: "",
                fuentes: "",
                estado_actual: "",
                lecciones: "",
                images: '',                
            },
            actores: [],
            FiltroActores: [],
            municipios: [],
            FiltroMunicipios: [],
            deptos: [],
            FiltroDeptos: [],
            cardState: {},
            search: '',
            filteredCasos: [],
            menu1: false,
            map: null,
            casoxdepto: [],
            headers: [
                { text: 'Acciones', value: 'actions', sortable: false },
                { text: 'Nombre del Caso', value: 'nom_caso', width: '150px' }, 
                { text: 'Fecha', value: 'fecha' },
                { text: 'Municipio', value: 'nom_municipio' },
                { text: 'Depto', value: 'nom_depto' },
                { text: 'Área protegia involucrada', value: 'area_protegida' },
                { text: 'Actores involucrados', value: 'nom_actores'},
                { text: 'Tipo de delito', value: 'tipo_delito' },
                { text: 'Tipo de corrupción', value: 'tipo_corrupcion' },
                { text: 'Condena', value: 'condena' },
                { text: 'Resolución', value: 'resolucion' },
                { text: 'Año de apertura de la investigación', value: 'año_investigacion' },
                { text: 'Tipo de sanción', value: 'tipo_sancion' },
                { text: 'Monto de dinero', value: 'monto' },
                { text: 'Beneficios ilegales', value: 'beneficios_ilegal' },
                { text: 'Perjuicios', value: 'perjuicios' },
                { text: 'Tipo de daño', value: 'tipo_daño' },
                { text: 'Mecanismos utilizados', value: 'mecanismo' },
                { text: 'Sector afectado', value: 'sector_afectado' },
                { text: 'Investigación y juicio', value: 'investigacion' },
                { text: 'Sanciones', value: 'sancion' },
                { text: 'Impacto social', value: 'imp_social' },
                { text: 'Impacto Economico', value: 'imp_economico' },
                { text: 'Fuentes de información', value: 'fuentes' },
                { text: 'Estado actual', value: 'estado_actual' },
                { text: 'Lecciones aprendidas', value: 'lecciones' },
            ],
            dialog: false,
            formTitle: '',
            dialogdetail: false,
            showConfirmDialog: false,
            isNew: true,
            dialog_guardando: false,
            guardarExitoso: false,
        };  
    },
    mounted() {
        this.listar();
        if (this.$route.hash) {
            VueScrollTo.scrollTo(this.$route.hash, 500);
        }
        this.initializeMap();
        this.addDeptosToMap();
    },
    watch: {
        '$route' (to, from) {
            if (to.hash) {
                VueScrollTo.scrollTo(to.hash, 500);
            }
        }
    },
    created() {
        this.listar();
    },
    computed: {
        filtered() {
            let filteredBySearch = this.datos.filter(caso => {
                if (caso.nom_caso) {
                    return caso.nom_caso.toLowerCase().includes(this.search.toLowerCase());
                } else {
                    return false;
                }
            });

            if (this.FiltroActores.length > 0) {
                filteredBySearch = filteredBySearch.filter(caso => this.FiltroActores.includes(caso.oid_actor));
            }
            if (this.FiltroDeptos.length > 0) {
                filteredBySearch = filteredBySearch.filter(caso => this.FiltroDeptos.includes(caso.oid_depto));
            }
            if (this.FiltroMunicipios.length > 0) {
                filteredBySearch = filteredBySearch.filter(caso => this.FiltroMunicipios.includes(caso.oid_municipio));
            }

            return filteredBySearch;
        },
        optionsActores() {
            return [
                //{ oid: null, titulo: 'Todos' }, // Opción por defecto "Todos"
                ...this.actores // Agregar las texturas obtenidas de la base de datos
            ];
        },
        optionsMunicipios() {
            return [
                //{ oid: null, titulo: 'Todos' }, // Opción por defecto "Todos"
                ...this.municipios // Agregar las texturas obtenidas de la base de datos
            ];
        },
        optionsDeptos() {
            return [
                //{ oid: null, titulo: 'Todos' }, // Opción por defecto "Todos"
                ...this.deptos // Agregar las texturas obtenidas de la base de datos
            ];
        },
    },
    methods: {
        // Obtener la lista de Categiries
        async listar() {
            try {
                /*const response = await axios.get('casos', {
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json'
                    }
                });*/
                const response = await axios.get('casos');
                const responseActor = await axios.get('actores');
                const responseMunicipio = await axios.get('municipios');
                const responseDepto = await axios.get('deptos');

                // Extrae el arreglo de actores del objeto de respuesta
                if (responseActor.data && Array.isArray(responseActor.data.actores)) {
                    this.actores = responseActor.data.actores;
                } else {
                    console.error('Los datos de actores no son un arreglo:', responseActor.data);
                }

                // Extrae el arreglo de municipios del objeto de respuesta
                if (responseMunicipio.data && Array.isArray(responseMunicipio.data.municipios)) {
                    this.municipios = responseMunicipio.data.municipios;
                } else {
                    console.error('Los datos de municipios no son un arreglo:', responseMunicipio.data);
                }

                // Extrae el arreglo de deptos del objeto de respuesta
                if (responseDepto.data && Array.isArray(responseDepto.data.deptos)) {
                    this.deptos = responseDepto.data.deptos;
                } else {
                    console.error('Los datos de deptos no son un arreglo:', responseDepto.data);
                }

                // Verifica si los datos de los casos son un arreglo
                if (Array.isArray(response.data.casos)) {
                    this.datos = response.data.casos;

                    // Ahora que tienes los datos, puedes mapearlos al formato que esperas para las tarjetas ()
                    this.datos = this.datos.map(caso => {
                        return {
                            id: caso.oid,
                            nom_caso: caso.nom_caso,
                            fecha: caso.fecha,
                            oid_municipio: caso.oid_municipio,
                            oid_depto: caso.oid_depto,
                            oid_actor: caso.oid_actor,
                            nom_municipio: this.NMunicipio(caso.oid_municipio),
                            nom_depto: this.NDepto(caso.oid_depto),
                            area_protegida: caso.area_protegida,
                            nom_actores: this.NActores(caso.oid_actor),
                            tipo_delito: caso.tipo_delito,
                            tipo_corrupcion: caso.tipo_corrupcion,
                            condena: caso.condena,
                            resolucion: caso.resolucion,
                            año_investigacion: caso.año_investigacion,
                            tipo_sancion: caso.tipo_sancion,
                            monto: caso.monto,
                            beneficios_ilegal: caso.beneficios_ilegal,
                            perjuicios: caso.perjuicios,
                            tipo_daño: caso.tipo_daño,
                            mecanismo: caso.mecanismo,
                            sector_afectado: caso.sector_afectado,
                            investigacion: caso.investigacion,
                            sancion: caso.sancion,
                            imp_social: caso.imp_social,
                            imp_economico: caso.imp_economico,
                            fuentes: caso.fuentes,
                            estado_actual: caso.estado_actual,
                            lecciones: caso.lecciones,
                            images: ['logo3.png'],
                        };
                    });
                } else {
                    console.error('Los datos recibidos no son un arreglo:', response.data.casos);
                }
            } catch (error) {
                console.error(error);
            }
        },
        initializeMap() {
            this.map = L.map('map').setView([3.43722, -76.5225], 5); // Coordenadas de Colombia

                L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                maxZoom: 19,
                attribution: '&copy; OpenStreetMap contributors',
                referrerPolicy: 'strict-origin-when-cross-origin'
                }).addTo(this.map)

          /*  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                maxZoom: 18,
                attribution: '© OpenStreetMap'
            }).addTo(this.map);*/
        },
        async addDeptosToMap() {
            if (!this.map) {
                this.initializeMap();
            }

            try {
                const responseCasoxDepto = await axios.get('casoxdeptos');
                const registros = responseCasoxDepto.data?.casoxdepto;

                if (!Array.isArray(registros)) {
                    console.error('Los datos de casoxdepto no son un arreglo:', responseCasoxDepto.data);
                    return;
                }

                this.casoxdepto = registros.map((cxd) => ({
                    oid_depto: cxd.oid_depto,
                    n_depto: cxd.n_depto,
                    lat: cxd.lat,
                    lng: cxd.lng,
                    num_caso: cxd.num_caso,
                }));

                this.casoxdepto.forEach((depto) => {
                    if (depto.lat && depto.lng) {
                        const color = this.getColor(depto.num_caso);
                        const circle = L.circle([depto.lat, depto.lng], {
                            color,
                            fillColor: color,
                            fillOpacity: 0.5,
                            radius: 25000,
                        }).addTo(this.map);

                        circle.bindPopup(`
                            <b>${depto.n_depto}</b><br>
                            # de Casos: ${depto.num_caso}
                        `);
                    } else {
                        console.warn(`Coordenadas inválidas para el departamento: ${depto.n_depto}`);
                    }
                });
            } catch (error) {
                console.error('Error cargando casoxdeptos:', error);
            }
        },
        getColor(numCasos) {
            return numCasos > 40 ? 'red'
                : numCasos > 30 ? 'orange'
                : numCasos > 20 ? 'yellow'
                : 'green';
        },
        NActores(oid_actor) {
            if (Array.isArray(this.actores)) {
                const actor = this.actores.find(actor => actor.oid === oid_actor);
                return actor ? actor.n_actor : '';
            } else {
                console.error('this.actores is not an array:', this.actores);
                return '';
            }
        },
        NMunicipio(oid_municipio) {
            if (Array.isArray(this.municipios)) {
                const municipio = this.municipios.find(municipio => municipio.oid === oid_municipio);
                return municipio ? municipio.n_municipio : '';
            } else {
                console.error('this.municipios is not an array:', this.municipios);
                return '';
            }
        },
        NDepto(oid_depto) {
            if (Array.isArray(this.deptos)) {
                const depto = this.deptos.find(depto => depto.oid === oid_depto);
                return depto ? depto.n_depto : '';
            } else {
                console.error('this.deptos is not an array:', this.deptos);
                return '';
            }
        },
        // Mostrar detalles de un área
        async mostrar(id) {            
            try {
                const response = await axios.get(`casos/${id}`);
                this.dato = response.data.caso;
                this.dialogdetail = true;
            } catch (error) {
                console.error(error);
            }
        },
        
        // Abrir el diálogo para crear una nueva área
        nueva() {
            this.dato = { oid: 0, nom_caso: '', fecha: null, oid_municipio: null, oid_depto: null, area_protegida: '', oid_actor: null, tipo_delito: '',tipo_corrupcion: '', condena: "", resolucion: "", año_investigacion: 0, tipo_sancion: "", monto: "", beneficios_ilegal: "", perjuicios: "", tipo_daño: "", mecanismo: "", sector_afectado: "", investigacion: "", sancion: "", imp_social: "", imp_economico: "", fuentes: "", estado_actual: "", lecciones: "" };
            this.isNew = true;
            this.formTitle = 'Caso Nuevo';
            this.dialog = true;
        },
        // Abrir el diálogo para editar un área existente
        editar(dato) {
            this.dato = { ...dato };
            this.isNew = false;
            this.formTitle = 'Actualizar Caso';
            this.dialog = true;
        },
        // Guardar el área creada o actualizada
        async guardar() {
            this.dialog_guardando = true;
            const id = this.dato.id;
                try {
                    const csrfToken = await obtenerTokenCSRF();
                    // Realizar la lógica para guardar o actualizar el área
                    if (this.isNew) {
                        // Crear el área
                        await axios.post('casos', this.dato);
                    } else {
                        // Actualizar el área
                        await axios.put(`casos/${id}`, this.dato);
                    }
                    // Limpiar el formulario después de guardar o actualizar
                    this.dato = { oid: 0, nom_caso: '', fecha: null, oid_municipio: null, oid_depto: null, area_protegida: '', oid_actor: null, tipo_delito: '',tipo_corrupcion: '', condena: "", resolucion: "", año_investigacion: 0, tipo_sancion: "", monto: "", beneficios_ilegal: "", perjuicios: "", tipo_daño: "", mecanismo: "", sector_afectado: "", investigacion: "", sancion: "", imp_social: "", imp_economico: "", fuentes: "", estado_actual: "", lecciones: "" };

                    // Después de guardar exitosamente el registro:
                    this.guardarExitoso = true;
                    this.dialog = false;
                    await this.listar();
                    
                } catch (error) {
                    console.error(error);
                } finally {
                    // Independientemente de si la solicitud tuvo éxito o no, detenemos el estado de carga.
                    this.dialog_guardando = false;
                }
        },
        // Eliminar un área
        async eliminar(id) {
            try {
                await axios.delete(`casos/${id}`);
                
                this.listar();
                this.cancelarEliminar();
            } catch (error) {
                console.error(error);
            }
        },

        // Confirmar eliminación de un área
        confirmarEliminar(id) {
            this.confirmItemId = id;
            this.showConfirmDialog = true;
        },
        // Cancelar eliminación
        cancelarEliminar() {
            this.confirmItemId = null;
            this.showConfirmDialog = false;
        },        
        // Cancelar Detalle
        cancelarDetalle() {
            this.dialogdetail = false;            
        },
        cerrar() {
            this.dialog = false;
        },

        
        getImageSrc(filename) {
            return require(`../../assets/${filename}`);
        },
        flipCard(cardId, isFlipped) {
            // Verificar si cardState[cardId] existe antes de acceder a sus propiedades
            if (this.cardState[cardId]) {
                this.$set(this.cardState[cardId], 'isFlipped', isFlipped);
            } else {
                // Si no existe, inicialízalo con isFlipped
                this.$set(this.cardState, cardId, { isFlipped });
            }
        },
        validarnumero(value) {
            const num = /^[0-9]+$/; // Expresión regular para verificar si el valor son solo dígitos
            if (!num.test(value)) {
                return 'El campo solo puede contener números';
            }
            return true;
        },
    },
};
</script>
<style>
    #map {
        height: 600px;
        width: 100%;    
        position: relative;
        z-index: 1;
    }
    .v-card {
        perspective: 1000px;
        transition: transform 0.5s;
    }

    .v-card.is-flipped {
        transform: rotateY(180deg);
    }

    .custom-h1 {
        font-size: 2.5em; /* Puedes ajustar el tamaño según tus necesidades */
        font-weight: bold; /* Otras propiedades de estilo si es necesario */
    }

    .custom-h3 {
        font-size: 1.5em; /* Puedes ajustar el tamaño según tus necesidades */  
    }
    p {
        /* font-family: 'Heebo', sans-serif !important; */
        font-family: 'Roboto' !important;
        font-size: 14px;      
        line-height: 1.6em;
        text-align: justify;
    }
    h1 {
        font-family: 'Heebo', sans-serif;
        text-align: center;
    }
    h2 {
        /* font-family: 'Heebo', sans-serif; */
        font-family: 'Roboto' !important;
        font-size: 18px;
        text-align: left;  
    }
    h3 {
        font-family: 'Heebo', sans-serif;
    }
    .p1{
        font-size: 17px; 
        color: rgb(15, 135, 201); 
        line-height: 1em;
    }
</style>